module.exports = __webpack_public_path__ + "assets/paishe.d0c5a6aa.svg";